import React, { useState, Dispatch, SetStateAction } from 'react';
import OptionModal from '../../../../../components/modals/option-modal';
import { useParams } from 'react-router';
import {
  ButtonComponent,
  ButtonStyling,
} from '../../../../../components/form/elements/button';
import { useTranslation } from 'react-i18next';
import { useService } from '../../../../../services/services';
import css from '../view.module.css';

interface Props {
  notesId: string;
  update: boolean;
  setUpdate: Dispatch<SetStateAction<boolean>>;
  animalGroupId: string;
  apiRoutePrefix: string;
}

export default function DeleteNoteModal({
  notesId,
  update,
  setUpdate,
  animalGroupId,
  apiRoutePrefix,
}: Props) {
  const { farmId } = useParams<{ farmId: string; id: string }>();
  const [isVisible, setIsVisible] = useState(false);
  const transKeyPrefix = 'pages.livestock.animals_and_events.animals';
  const { groupAnimalService } = useService();
  const { t } = useTranslation();

  return (
    <span>
      <span className={css['notes-edit-left']}>
        <ButtonComponent
          name="delete"
          label={t('delete')}
          click={() => setIsVisible(true)}
          styling={ButtonStyling.cancel}
        />
      </span>
      {isVisible && (
        <OptionModal
          title={t(`${transKeyPrefix}.delete_note_text`)}
          buttons={[
            { title: t('Yes'), name: 'yes', value: true },
            { title: t('No'), name: 'no', value: false },
          ]}
          onChoice={(el) => {
            if (el) {
              groupAnimalService
                .deleteNote(farmId, animalGroupId, notesId, apiRoutePrefix)
                .subscribe(() => setUpdate(!update));
              setIsVisible(false);
            } else {
              setIsVisible(false);
            }
          }}
          onClose={() => setIsVisible(false)}
        />
      )}
    </span>
  );
}
